import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LikeReactionPayload, Reaction, Resource } from '@yandex-int/k-common';
import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';

import { LikesCount, LikesStoreState } from './typings';

const initialState: LikesStoreState = {
    clessonLikes: {},
    resourceLoadingStatuses: {},
    resources: {},
};

const slice = createSlice({
    name: 'LIKES',
    initialState: initialState,
    reducers: {
        // Параметры нужны для саги
        /* eslint-disable @typescript-eslint/no-unused-vars */
        getClessonReactions: (
            state: LikesStoreState,
            action: PayloadAction<{
                clessonIds: number[];
            }>
        ) => {
            // saga
        },
        /* eslint-enable @typescript-eslint/no-unused-vars */

        getClessonReactionsSuccess: (
            state: LikesStoreState,
            action: PayloadAction<{
                reactions: Reaction<LikeReactionPayload>[];
            }>
        ) => {
            const { reactions } = action.payload;
            const newLikes = reactions.reduce(
                (result, reaction) => {
                    const clessonId = Number(reaction.context_id);
                    if (!result[clessonId]) {
                        result[clessonId] = {};
                    }
                    const { slug } = reaction.payload;
                    if (!result[clessonId][slug]) {
                        result[clessonId][slug] = 0;
                    }
                    result[clessonId][slug] += 1;

                    return result;
                },
                {} as Record<number, LikesCount>
            );

            state.clessonLikes = { ...state.clessonLikes, ...newLikes };
        },

        getResourcesRequest: (
            state: LikesStoreState,
            action: PayloadAction<{
                resourceIds: number[];
            }>
        ) => {
            const { resourceIds } = action.payload;
            const next = resourceIds.reduce(
                (result, id) => {
                    result[id] = LOADING_STATUSES.LOADING;
                    return result;
                },
                {} as Record<number, LOADING_STATUSES>
            );

            state.resourceLoadingStatuses = {
                ...state.resourceLoadingStatuses,
                ...next,
            };
        },

        getResourcesRequestSuccess: (
            state: LikesStoreState,
            action: PayloadAction<{
                resources: Resource[];
            }>
        ) => {
            const resources: Record<number, Resource> = {};
            const resourcesLoadingStatuses: Record<number, LOADING_STATUSES> = {};
            action.payload.resources.forEach((resource) => {
                resources[resource.id] = resource;
                resourcesLoadingStatuses[resource.id] = LOADING_STATUSES.SUCCESS;
            });

            state.resourceLoadingStatuses = {
                ...state.resourceLoadingStatuses,
                ...resourcesLoadingStatuses,
            };
            state.resources = {
                ...state.resources,
                ...resources,
            };
        },
    },
});

export const likesActions = slice.actions;
export const likesReducer = slice.reducer;
